
import Vue from 'vue'

export default Vue.extend({
  name: 'Breadcrumb',
  computed: {
    breadcrumbItems(): { text: string; to: string | object }[] {

      const routeName = this.$route.meta?.title

      switch (routeName) {
        case 'EvaluationForm':
          return [
            { text: 'Home', to: '/' },
            { text: 'Project Code', to: '/evaluation-list' },
            { text: 'New Project Code', to: '/evaluation-form' }
          ]
        case 'EvaluationList':
          return [
            { text: 'Home', to: '/' },
            { text: 'Project Code', to: '/evaluation-list' }
          ]
        case 'ProjectCode':
          return [
            { text: 'Home', to: '/' },
            { text: 'Project Code', to: { path: '/evaluation-list', query: this.$route.query } },
            { text: 'New Project Code', to: '/new-project-code' }
          ]
        default: {
          const breadcrumb = this.$route.meta?.breadcrumb
          return [
            { text: 'Home', to: '/' },
            { text: breadcrumb || routeName, to: this.$route.path }
          ]
        }
      }
    }

  }
})
